<template>
    <v-autocomplete :value="value" @change="$emit('change', $event)" :items="stores" :filter="customFilter" item-value="id" item-text="name" :label="label" :multiple="multiple" :disabled="disabled"
        :return-object="returnObject" deletable-chips small-chips :rules="rules" dense>
        <template v-slot:item="data">
            <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                <v-list-item-subtitle v-html="data.item.referenceCode"></v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>

export default {
    name: "StoreSelect",

    props: {
        value: {
            required: true,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "Loja",
        },
        filter: {
            type: String,
        },
        endpoint: {
            type: String,
        },
    },

    data() {
        return {
            stores: null,
        };
    },

    methods: {
        customFilter(item, queryText) {
            const searchText = queryText.toLowerCase();
            return (item.name && item.name.toLowerCase().indexOf(searchText) > -1) || (item.email && item.email.toLowerCase().indexOf(searchText) > -1);
        },
        getUsers() {
            this.$http
                .get(this.endpoint ? this.endpoint : (this.filter ? `stores/${this.filter}` : "stores?enable=true"))
                .then((result) => {
                    if (result) {
                        this.stores = result;
                    }
                })
                .catch(() => {
                    this.stores = null;
                });
        },
    },

    mounted() {
        this.getUsers();
    },
};
</script>